// import React, { useEffect, useState, useCallback, useMemo } from 'react';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   Chip,
//   Typography,
//   Grid,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableRow,
//   Checkbox,
//   Autocomplete,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   Avatar,
//   Snackbar,
//   Alert,
//   AlertTitle,
//   CircularProgress,
//   Input
// } from '@mui/material';
// import { Theme } from '@mui/material/styles';
// import { useForm, Controller } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   addGroup,
//   updateGroup,
//   fetchAvatars,
//   deleteGroup
// } from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
// import { fetchUsers } from 'Pages/UserManagement/UserSlice';
// import { fetchServices } from 'slices/NdisSlices/platformAdmin/ManageServicesSlice';
// import { RootState } from 'app/store';
// import ClearIcon from '@mui/icons-material/Clear';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { Service, User } from 'types/ndisSection/platformAdminTypes';
// import debounce from 'lodash/debounce';

// // Define FormData interface
// interface FormData {
//   label: string;
//   description?: string;
//   tags?: string;
//   administrators?: string[];
//   services?: string[];
//   avatar?: File | string | undefined;
//   group_id?: string;
// }

// // Define Yup schema with explicit type matching FormData
// const schema = yup.object().shape({
//   label: yup.string().required('Label is required').min(3, 'Label must be at least 3 characters'),
//   description: yup.string().optional(),
//   tags: yup.string().optional(),
//   administrators: yup.array().of(yup.string().required('Administrator is required')).optional(),
//   services: yup.array().of(yup.string().required('Service is required')).optional(),
//   avatar: yup
//     .mixed<File | string>()
//     .optional()
//     .test('fileType', 'Invalid file type', (value) => {
//       if (!value) return true; // Allow undefined
//       if (typeof value === 'string') return true; // Allow existing avatar identifiers
//       return value instanceof File && value.type.startsWith('image/');
//     }),
//   group_id: yup.string().optional()
// }) as yup.ObjectSchema<FormData>;

// interface Props {
//   open: boolean;
//   editMode: boolean;
//   handleClose: () => void;
//   currentGroup: (FormData & { group_id?: string; avatar?: string }) | null;
// }

// const GroupsAddEditModal: React.FC<Props> = ({ open, handleClose, currentGroup, editMode }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

//   const {
//     control,
//     handleSubmit,
//     watch,
//     setValue,
//     reset,
//     formState: { errors, isDirty }
//   } = useForm<FormData>({
//     resolver: yupResolver(schema),
//     defaultValues: currentGroup ?? {
//       label: '',
//       description: '',
//       tags: '',
//       administrators: [],
//       services: [],
//       avatar: undefined,
//       group_id: undefined
//     }
//   });

//   const dispatch = useDispatch();
//   const { services } = useSelector((state: RootState) => state.manageServices);
//   const { users, avatarUrls, error, loading } = useSelector((state: RootState) => ({
//     users: state.usermanagement.users,
//     avatarUrls: state.platformAdmin.avatarUrls,
//     error: state.platformAdmin.error,
//     loading: state.platformAdmin.loading
//   }));

//   const [searchQuery, setSearchQuery] = useState('');
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'success' as 'success' | 'error' | 'info' | 'warning'
//   });
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
//   const [avatarPreview, setAvatarPreview] = useState<string | null>(null);

//   const filteredUsers = useMemo(
//     () =>
//       users.filter((user: User) => user.email.toLowerCase().includes(searchQuery.toLowerCase())),
//     [users, searchQuery]
//   );

//   const debouncedFetchAvatars = useCallback(
//     debounce((usersToFetch: User[]) => {
//       if (usersToFetch.length > 0) {
//         dispatch(fetchAvatars(usersToFetch));
//       }
//     }, 300),
//     [dispatch]
//   );

//   useEffect(() => {
//     dispatch(fetchUsers());
//     dispatch(fetchServices());
//   }, [dispatch]);

//   useEffect(() => {
//     const usersToFetch = filteredUsers.filter((user: User) => !avatarUrls[user.id]);
//     if (usersToFetch.length > 0) {
//       debouncedFetchAvatars(usersToFetch);
//     }
//     return () => {
//       debouncedFetchAvatars.cancel();
//     };
//   }, [filteredUsers, avatarUrls, debouncedFetchAvatars]);

//   useEffect(() => {
//     if (currentGroup) {
//       reset({
//         label: currentGroup.label,
//         description: currentGroup.description,
//         tags: currentGroup.tags || '',
//         administrators: currentGroup.administrators || [],
//         services: currentGroup.services || [],
//         avatar: currentGroup.avatar || undefined,
//         group_id: currentGroup.group_id
//       });
//       setAvatarPreview(
//         currentGroup.avatar && currentGroup.avatar.startsWith('data:image/')
//           ? currentGroup.avatar
//           : null
//       );
//     } else {
//       reset({
//         label: '',
//         description: '',
//         tags: '',
//         administrators: [],
//         services: [],
//         avatar: undefined,
//         group_id: undefined
//       });
//       setAvatarPreview(null);
//     }
//   }, [currentGroup, reset]);

//   useEffect(() => {
//     if (error) {

//       console.log("error",error)
//       setSnackbar({
//         open: true,
//         message: error,
//         severity: 'error'
//       });
//     }
//   }, [error]);

//   const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const file = event.target.files?.[0];
//     if (file) {
//       setValue('avatar', file);
//       setAvatarPreview(URL.createObjectURL(file));
//     }
//   };

//   const fileToBase64 = (file: File): Promise<string> => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result as string);
//       reader.onerror = (error) => reject(error);
//       reader.readAsDataURL(file);
//     });
//   };

//   const onSubmit = async (data: FormData) => {
//     let avatarString: string | undefined;
//     if (data.avatar instanceof File) {
//       try {
//         avatarString = await fileToBase64(data.avatar);
//       } catch (err) {
//         setSnackbar({
//           open: true,
//           message: 'Failed to process avatar. Please try again.',
//           severity: 'error'
//         });
//         return;
//       }
//     } else if (editMode && data.avatar === currentGroup?.avatar) {
//       avatarString = currentGroup?.avatar; // Retain existing avatar
//     } else {
//       avatarString = undefined; // No avatar
//     }

//     const payload = {
//       label: data.label,
//       description: data.description || '',
//       avatar: avatarString,
//       tags: data.tags ? data.tags.split(',').filter(Boolean) : [],
//       administrators: data.administrators || [],
//       services: data.services || [],
//       ...(editMode && data.group_id ? { group_id: data.group_id } : {})
//     };

//     try {
//       if (editMode) {
//         await dispatch(updateGroup(payload));
//         setSnackbar({
//           open: true,
//           message: 'Group updated successfully!',
//           severity: 'success'
//         });
//       } else {
//         await dispatch(addGroup(payload));
//         setSnackbar({
//           open: true,
//           message: 'Group created successfully!',
//           severity: 'success'
//         });
//       }
//       handleClose();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: 'Failed to save group. Please try again.',
//         severity: 'error'
//       });
//     }
//   };

//   const onError = () => {
//     setSnackbar({
//       open: true,
//       message: 'Please fix the form errors before submitting.',
//       severity: 'error'
//     });
//   };

//   const handleDeleteGroup = async () => {
//     if (!currentGroup?.group_id) return;
//     try {
//       await dispatch(deleteGroup(currentGroup.group_id));
//       setSnackbar({
//         open: true,
//         message: 'Group deleted successfully!',
//         severity: 'success'
//       });
//       handleClose();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: 'Failed to delete group. Please try again.',
//         severity: 'error'
//       });
//     }
//     setDeleteConfirmOpen(false);
//   };

//   const handleCloseWithCheck = () => {
//     if (isDirty) {
//       setConfirmDialogOpen(true);
//     } else {
//       handleClose();
//     }
//   };

//   const handleConfirmClose = () => {
//     setConfirmDialogOpen(false);
//     handleClose();
//   };

//   const handleCancelClose = () => {
//     setConfirmDialogOpen(false);
//   };

//   const handleOpenDeleteConfirm = () => {
//     setDeleteConfirmOpen(true);
//   };

//   const handleCloseDeleteConfirm = () => {
//     setDeleteConfirmOpen(false);
//   };

//   const handleDeleteChip = (
//     field: 'tags' | 'administrators' | 'services',
//     chipToDelete: string
//   ) => {
//     const fieldValue = watch(field) || [];
//     setValue(
//       field,
//       (Array.isArray(fieldValue) ? fieldValue : [fieldValue]).filter(
//         (chip: string) => chip !== chipToDelete
//       )
//     );
//   };

//   const handleSnackbarClose = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={handleCloseWithCheck}
//         fullWidth
//         maxWidth="lg"
//         fullScreen={isMobile}
//         PaperProps={{
//           style: {
//             borderRadius: isMobile ? 0 : 12,
//             boxShadow: theme.shadows[10],
//             maxHeight: '90vh',
//             overflow: 'hidden',
//             margin: isMobile ? 0 : 'auto',
//             width: isMobile ? '100%' : 'auto'
//           }
//         }}
//       >
//         <DialogTitle
//           sx={{
//             py: isMobile ? 1 : 2,
//             px: isMobile ? 2 : 3,
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             backgroundColor: theme.palette.background.paper
//           }}
//         >
//           <Typography variant={isMobile ? 'subtitle1' : 'h6'} fontWeight="bold">
//             {editMode ? 'Edit Group' : 'Add Group'}
//           </Typography>
//           <Box>
//             {editMode && (
//               <IconButton
//                 onClick={handleOpenDeleteConfirm}
//                 size={isMobile ? 'small' : 'medium'}
//                 color="error"
//                 disabled={loading}
//               >
//                 <DeleteIcon fontSize={isMobile ? 'small' : 'medium'} />
//               </IconButton>
//             )}
//             <IconButton
//               onClick={handleCloseWithCheck}
//               size={isMobile ? 'small' : 'medium'}
//               disabled={loading}
//             >
//               <ClearIcon fontSize={isMobile ? 'small' : 'medium'} />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent sx={{ p: isMobile ? 1 : 3 }}>
//           <Grid container spacing={isMobile ? 1 : 3}>
//             <Grid item xs={12} md={4}>
//               <Box sx={{ mb: isMobile ? 1 : 3 }}>
//                 <Typography
//                   variant={isMobile ? 'subtitle2' : 'h6'}
//                   fontWeight="bold"
//                   color="textPrimary"
//                   gutterBottom
//                 >
//                   Community Details
//                 </Typography>
//                 <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
//                   <Avatar
//                     src={avatarPreview || undefined}
//                     sx={{
//                       width: isMobile ? 80 : 100,
//                       height: isMobile ? 80 : 100,
//                       mb: 1,
//                       bgcolor: '#1976D2',
//                       fontSize: isMobile ? '1.5rem' : '2rem'
//                     }}
//                   >
//                     {watch('label')?.charAt(0).toUpperCase() || '?'}
//                   </Avatar>
//                 </Box>
//                 <Controller
//                   name="avatar"
//                   control={control}
//                   render={({ field }) => (
//                     <Input
//                       type="file"
//                       inputProps={{ accept: 'image/*' }}
//                       onChange={handleAvatarChange}
//                       fullWidth
//                       disabled={loading}
//                       sx={{ mb: isMobile ? 1 : 2 }}
//                       // @ts-ignore
//                       error={!!errors.avatar}
//                       // @ts-ignore
//                       helperText={errors.avatar?.message}
//                     />
//                   )}
//                 />
//                 <Controller
//                   name="label"
//                   control={control}
//                   render={({ field }) => (
//                     <TextField
//                       {...field}
//                       label="Community Name"
//                       fullWidth
//                       margin="normal"
//                       error={!!errors.label}
//                       helperText={errors.label?.message}
//                       sx={{ mb: isMobile ? 1 : 2 }}
//                       size={isMobile ? 'small' : 'medium'}
//                       disabled={loading}
//                     />
//                   )}
//                 />
//                 <Controller
//                   name="description"
//                   control={control}
//                   render={({ field }) => (
//                     <TextField
//                       {...field}
//                       label="Community Description"
//                       fullWidth
//                       multiline
//                       rows={isMobile ? 2 : 4}
//                       margin="normal"
//                       error={!!errors.description}
//                       helperText={errors.description?.message}
//                       sx={{ mb: isMobile ? 1 : 2 }}
//                       size={isMobile ? 'small' : 'medium'}
//                       disabled={loading}
//                     />
//                   )}
//                 />
//                 <Controller
//                   name="tags"
//                   control={control}
//                   render={({ field }) => (
//                     <Autocomplete
//                       multiple
//                       freeSolo
//                       value={field.value ? field.value.split(',').filter(Boolean) : []}
//                       options={[]}
//                       clearIcon={<ClearIcon fontSize={isMobile ? 'small' : 'medium'} />}
//                       onChange={(e, newval) => setValue('tags', newval.join(','))}
//                       disabled={loading}
//                       renderTags={(value, getTagProps) =>
//                         value.map((option, index) => (
//                           <Chip
//                             label={option}
//                             {...getTagProps({ index })}
//                             onDelete={() => handleDeleteChip('tags', option)}
//                             sx={{
//                               mr: 0.5,
//                               mb: 0.5,
//                               fontSize: isMobile ? '0.75rem' : '0.875rem'
//                             }}
//                             size={isMobile ? 'small' : 'medium'}
//                           />
//                         ))
//                       }
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="Community Tags"
//                           placeholder="Type and press enter"
//                           margin="normal"
//                           error={!!errors.tags}
//                           helperText={errors.tags?.message}
//                           sx={{ mb: isMobile ? 1 : 2 }}
//                           size={isMobile ? 'small' : 'medium'}
//                         />
//                       )}
//                     />
//                   )}
//                 />
//                 <Controller
//                   name="services"
//                   control={control}
//                   render={({ field }) => (
//                     <Autocomplete
//                       multiple
//                       value={
//                         field.value && services.length > 0
//                           ? services.filter((service: Service) =>
//                               field.value!.includes(service.service_id)
//                             )
//                           : []
//                       }
//                       options={services}
//                       getOptionLabel={(option: Service) =>
//                         option.header || option.shortDescription || option.service_id || 'Unknown'
//                       }
//                       clearIcon={<ClearIcon fontSize={isMobile ? 'small' : 'medium'} />}
//                       onChange={(e, newval) =>
//                         setValue(
//                           'services',
//                           newval.map((service: Service) => service.service_id)
//                         )
//                       }
//                       disabled={loading || services.length === 0}
//                       renderTags={(value, getTagProps) =>
//                         value.map((option: Service, index: number) => (
//                           <Chip
//                             label={option.header || option.shortDescription || option.service_id}
//                             {...getTagProps({ index })}
//                             onDelete={() => handleDeleteChip('services', option.service_id)}
//                             sx={{
//                               mr: 0.5,
//                               mb: 0.5,
//                               fontSize: isMobile ? '0.75rem' : '0.875rem'
//                             }}
//                             size={isMobile ? 'small' : 'medium'}
//                           />
//                         ))
//                       }
//                       renderInput={(params) => (
//                         <TextField
//                           {...params}
//                           label="Services"
//                           placeholder={
//                             services.length > 0 ? 'Select services' : 'No services available'
//                           }
//                           margin="normal"
//                           error={!!errors.services}
//                           helperText={errors.services?.message}
//                           sx={{ mb: isMobile ? 1 : 2 }}
//                           size={isMobile ? 'small' : 'medium'}
//                         />
//                       )}
//                     />
//                   )}
//                 />
//               </Box>
//             </Grid>
//             <Grid item xs={12} md={8}>
//               <Box sx={{ mb: isMobile ? 1 : 3 }}>
//                 <Typography
//                   variant={isMobile ? 'subtitle2' : 'h6'}
//                   fontWeight="bold"
//                   color="textPrimary"
//                   gutterBottom
//                 >
//                   Select Administrators
//                 </Typography>
//                 <Box
//                   sx={{
//                     border: `1px solid ${theme.palette.divider}`,
//                     borderRadius: 1,
//                     p: isMobile ? 1 : 2,
//                     backgroundColor: theme.palette.background.paper,
//                     maxHeight: isMobile ? '40vh' : '60vh',
//                     overflowY: 'auto'
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: isMobile ? 1 : 2 }}>
//                     <TextField
//                       label="Search Administrators"
//                       fullWidth
//                       margin="normal"
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       sx={{ mr: 2 }}
//                       size={isMobile ? 'small' : 'medium'}
//                       disabled={loading}
//                     />
//                   </Box>
//                   {loading && filteredUsers.length === 0 ? (
//                     <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
//                       <CircularProgress />
//                     </Box>
//                   ) : (
//                     <TableContainer>
//                       <Table size={isMobile ? 'small' : 'medium'}>
//                         <TableBody>
//                           {filteredUsers.map((user: User) => {
//                             const isSelected = watch('administrators')?.includes(user.email);

//                             return (
//                               <TableRow
//                                 key={user.id}
//                                 sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
//                               >
//                                 <TableCell padding="checkbox" sx={{ py: isMobile ? 0.5 : 1 }}>
//                                   <Checkbox
//                                     checked={isSelected}
//                                     onChange={() => {
//                                       const adminsField = watch('administrators') || [];
//                                       if (isSelected) {
//                                         setValue(
//                                           'administrators',
//                                           adminsField.filter((email) => email !== user.email)
//                                         );
//                                       } else {
//                                         setValue('administrators', [...adminsField, user.email]);
//                                       }
//                                     }}
//                                     color="primary"
//                                     size={isMobile ? 'small' : 'medium'}
//                                     disabled={loading}
//                                   />
//                                 </TableCell>
//                                 <TableCell
//                                   align="left"
//                                   sx={{
//                                     width: 'auto',
//                                     minWidth: isMobile ? '100%' : 400,
//                                     py: isMobile ? 0.5 : 1
//                                   }}
//                                 >
//                                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <Avatar
//                                       src={avatarUrls[user.id]}
//                                       sx={{
//                                         width: isMobile ? 24 : 32,
//                                         height: isMobile ? 24 : 32,
//                                         fontSize: isMobile ? '0.75rem' : '0.875rem'
//                                       }}
//                                     >
//                                       {user.email.charAt(0).toUpperCase()}
//                                     </Avatar>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{
//                                         fontSize: isMobile ? '0.75rem' : '0.875rem',
//                                         whiteSpace: 'nowrap',
//                                         overflow: 'hidden',
//                                         textOverflow: 'ellipsis'
//                                       }}
//                                     >
//                                       {user.email}
//                                     </Typography>
//                                   </Box>
//                                 </TableCell>
//                               </TableRow>
//                             );
//                           })}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   )}
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions
//           sx={{
//             p: isMobile ? 1 : 2,
//             borderTop: `1px solid ${theme.palette.divider}`,
//             justifyContent: 'space-between'
//           }}
//         >
//           <Button
//             onClick={handleCloseWithCheck}
//             sx={{
//               color: 'text.secondary',
//               fontSize: isMobile ? '0.75rem' : '0.875rem',
//               px: isMobile ? 1 : 2
//             }}
//             disabled={loading}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSubmit(onSubmit, onError)}
//             variant="contained"
//             color="primary"
//             sx={{
//               fontSize: isMobile ? '0.75rem' : '0.875rem',
//               px: isMobile ? 1 : 2
//             }}
//             disabled={loading}
//           >
//             {loading ? <CircularProgress size={24} /> : editMode ? 'Save Changes' : 'Add Group'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Confirmation Dialog for Unsaved Changes */}
//       <Dialog open={confirmDialogOpen} onClose={handleCancelClose} maxWidth="xs" fullWidth>
//         <DialogTitle>Unsaved Changes</DialogTitle>
//         <DialogContent>
//           <Typography>You have unsaved changes. Are you sure you want to close?</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCancelClose} color="primary" disabled={loading}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleConfirmClose}
//             color="primary"
//             variant="contained"
//             disabled={loading}
//           >
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Confirmation Dialog for Delete Group */}
//       <Dialog open={deleteConfirmOpen} onClose={handleCloseDeleteConfirm} maxWidth="xs" fullWidth>
//         <DialogTitle>Delete Group</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to delete the group "{currentGroup?.label}"? This action cannot be
//             undone.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDeleteConfirm} color="primary" disabled={loading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDeleteGroup} color="error" variant="contained" disabled={loading}>
//             {loading ? <CircularProgress size={24} /> : 'Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for Toasts */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
//           <AlertTitle>
//             {snackbar.severity.charAt(0).toUpperCase() + snackbar.severity.slice(1)}
//           </AlertTitle>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default GroupsAddEditModal;

import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Chip,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Checkbox,
  Autocomplete,
  IconButton,
  useTheme,
  useMediaQuery,
  Avatar,
  Snackbar,
  Alert,
  AlertTitle,
  CircularProgress,
  Input
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector } from 'react-redux';
import {
  addGroup,
  updateGroup,
  fetchAvatars,
  deleteGroup,
  closeSnackbar,
  showSnackbar
} from 'slices/NdisSlices/platformAdmin/PlatformAdminSlice';
import { fetchUsers } from 'Pages/UserManagement/UserSlice';
import { fetchServices } from 'slices/NdisSlices/platformAdmin/ManageServicesSlice';
import { useAppDispatch } from 'app/hooks';
import { RootState } from 'app/store';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import { Service, User } from 'types/ndisSection/platformAdminTypes';
import debounce from 'lodash/debounce';

// Define FormData interface
interface FormData {
  label: string;
  description?: string;
  tags?: string;
  administrators?: string[];
  services?: string[];
  avatar?: File | string | undefined;
  group_id?: string;
}

// Define Yup schema with explicit type matching FormData
const schema = yup.object().shape({
  label: yup.string().required('Label is required').min(3, 'Label must be at least 3 characters'),
  description: yup.string().optional(),
  tags: yup.string().optional(),
  administrators: yup.array().of(yup.string().required('Administrator is required')).optional(),
  services: yup.array().of(yup.string().required('Service is required')).optional(),
  avatar: yup
    .mixed<File | string>()
    .optional()
    .test('fileType', 'Invalid file type', (value) => {
      if (!value) return true; // Allow undefined
      if (typeof value === 'string') return true; // Allow existing avatar identifiers
      return value instanceof File && value.type.startsWith('image/');
    }),
  group_id: yup.string().optional()
}) as yup.ObjectSchema<FormData>;

interface Props {
  open: boolean;
  editMode: boolean;
  handleClose: () => void;
  currentGroup: (FormData & { group_id?: string; avatar?: string }) | null;
}

const GroupsAddEditModal: React.FC<Props> = ({ open, handleClose, currentGroup, editMode }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isDirty }
  } = useForm<FormData>({
    resolver: yupResolver(schema),
    defaultValues: currentGroup ?? {
      label: '',
      description: '',
      tags: '',
      administrators: [],
      services: [],
      avatar: undefined,
      group_id: undefined
    }
  });

  const dispatch = useAppDispatch();
  const { services } = useSelector((state: RootState) => state.manageServices);
  const { users, avatarUrls, loading, snackbar } = useSelector((state: RootState) => ({
    users: state.usermanagement.users,
    avatarUrls: state.platformAdmin.avatarUrls,
    loading: state.platformAdmin.loading,
    snackbar: state.platformAdmin.snackbar
  }));

  const [searchQuery, setSearchQuery] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [avatarPreview, setAvatarPreview] = useState<string | null>(null);

  const normalizedSearchQuery = searchQuery.toLowerCase();

  const filteredUsers = useMemo(
    () =>
      users.filter((user: User) => {
        const email = typeof user?.email === 'string' ? user.email.trim() : '';
        return email.length > 0 && email.toLowerCase().includes(normalizedSearchQuery);
      }),
    [users, normalizedSearchQuery]
  );

  const debouncedFetchAvatars = useCallback(
    debounce((usersToFetch: User[]) => {
      if (usersToFetch.length > 0) {
        dispatch(fetchAvatars(usersToFetch));
      }
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchServices());
  }, [dispatch]);

  useEffect(() => {
    const usersToFetch = filteredUsers.filter((user: User) => !avatarUrls[user.id]);
    if (usersToFetch.length > 0) {
      debouncedFetchAvatars(usersToFetch);
    }
    return () => {
      debouncedFetchAvatars.cancel();
    };
  }, [filteredUsers, avatarUrls, debouncedFetchAvatars]);

  useEffect(() => {
    if (currentGroup) {
      reset({
        label: currentGroup.label,
        description: currentGroup.description,
        tags: currentGroup.tags || '',
        administrators: currentGroup.administrators || [],
        services: currentGroup.services || [],
        avatar: currentGroup.avatar || undefined,
        group_id: currentGroup.group_id
      });
      setAvatarPreview(
        currentGroup.avatar && currentGroup.avatar.startsWith('data:image/')
          ? currentGroup.avatar
          : null
      );
    } else {
      reset({
        label: '',
        description: '',
        tags: '',
        administrators: [],
        services: [],
        avatar: undefined,
        group_id: undefined
      });
      setAvatarPreview(null);
    }
  }, [currentGroup, reset]);

  const handleAvatarChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setValue('avatar', file);
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const onSubmit = async (data: FormData) => {
    let avatarString: string | undefined;
    if (data.avatar instanceof File) {
      try {
        avatarString = await fileToBase64(data.avatar);
      } catch (err) {
        dispatch(
          showSnackbar({
            message: 'Failed to process avatar. Please try again.',
            severity: 'error'
          })
        );
        return;
      }
    } else if (editMode && data.avatar === currentGroup?.avatar) {
      avatarString = currentGroup?.avatar; // Retain existing avatar
    } else {
      avatarString = undefined; // No avatar
    }

    const payload = {
      label: data.label,
      description: data.description || '',
      avatar: avatarString,
      tags: data.tags ? data.tags.split(',').filter(Boolean) : [],
      administrators: data.administrators || [],
      services: data.services || [],
      ...(editMode && data.group_id ? { group_id: data.group_id } : {})
    };

    try {
      const mutationThunk = editMode ? updateGroup(payload) : addGroup(payload);
      const wasSaved = await (dispatch(mutationThunk as any) as unknown as Promise<boolean>);

      if (wasSaved) {
        handleClose();
      }
    } catch (err) {
      // Error handling is now in the slice
    }
  };

  const onError = () => {
    dispatch(
      showSnackbar({
        message: 'Please fix the form errors before submitting.',
        severity: 'error'
      })
    );
  };

  const handleDeleteGroup = async () => {
    if (!currentGroup?.group_id) return;
    try {
      await dispatch(deleteGroup(currentGroup.group_id));
      handleClose();
    } catch (err) {
      // Error handling is now in the slice
    }
    setDeleteConfirmOpen(false);
  };

  const handleCloseWithCheck = () => {
    if (isDirty) {
      setConfirmDialogOpen(true);
    } else {
      handleClose();
    }
  };

  const handleConfirmClose = () => {
    setConfirmDialogOpen(false);
    handleClose();
  };

  const handleCancelClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleOpenDeleteConfirm = () => {
    setDeleteConfirmOpen(true);
  };

  const handleCloseDeleteConfirm = () => {
    setDeleteConfirmOpen(false);
  };

  const handleDeleteChip = (
    field: 'tags' | 'administrators' | 'services',
    chipToDelete: string
  ) => {
    const fieldValue = watch(field) || [];
    setValue(
      field,
      (Array.isArray(fieldValue) ? fieldValue : [fieldValue]).filter(
        (chip: string) => chip !== chipToDelete
      )
    );
  };

  const handleSnackbarClose = () => {
    dispatch(closeSnackbar());
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseWithCheck}
        fullWidth
        maxWidth="lg"
        fullScreen={isMobile}
        PaperProps={{
          style: {
            borderRadius: isMobile ? 0 : 12,
            boxShadow: theme.shadows[10],
            maxHeight: '90vh',
            overflow: 'hidden',
            margin: isMobile ? 0 : 'auto',
            width: isMobile ? '100%' : 'auto'
          }
        }}
      >
        <DialogTitle
          sx={{
            py: isMobile ? 1 : 2,
            px: isMobile ? 2 : 3,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: theme.palette.background.paper
          }}
        >
          <Typography variant={isMobile ? 'subtitle1' : 'h6'} fontWeight="bold">
            {editMode ? 'Edit Group' : 'Add Group'}
          </Typography>
          <Box>
            {editMode && (
              <IconButton
                onClick={handleOpenDeleteConfirm}
                size={isMobile ? 'small' : 'medium'}
                color="error"
                disabled={loading}
              >
                <DeleteIcon fontSize={isMobile ? 'small' : 'medium'} />
              </IconButton>
            )}
            <IconButton
              onClick={handleCloseWithCheck}
              size={isMobile ? 'small' : 'medium'}
              disabled={loading}
            >
              <ClearIcon fontSize={isMobile ? 'small' : 'medium'} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: isMobile ? 1 : 3 }}>
          <Grid container spacing={isMobile ? 1 : 3}>
            <Grid item xs={12} md={4}>
              <Box sx={{ mb: isMobile ? 1 : 3 }}>
                <Typography
                  variant={isMobile ? 'subtitle2' : 'h6'}
                  fontWeight="bold"
                  color="textPrimary"
                  gutterBottom
                >
                  Community Details
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                  <Avatar
                    src={avatarPreview || undefined}
                    sx={{
                      width: isMobile ? 80 : 100,
                      height: isMobile ? 80 : 100,
                      mb: 1,
                      bgcolor: '#1976D2',
                      fontSize: isMobile ? '1.5rem' : '2rem'
                    }}
                  >
                    {watch('label')?.charAt(0).toUpperCase() || '?'}
                  </Avatar>
                </Box>
                <Controller
                  name="avatar"
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="file"
                      inputProps={{ accept: 'image/*' }}
                      onChange={handleAvatarChange}
                      fullWidth
                      disabled={loading}
                      sx={{ mb: isMobile ? 1 : 2 }}
                      // @ts-ignore
                      error={!!errors.avatar}
                      // @ts-ignore
                      helperText={errors.avatar?.message}
                    />
                  )}
                />
                <Controller
                  name="label"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Community Name"
                      fullWidth
                      margin="normal"
                      error={!!errors.label}
                      helperText={errors.label?.message}
                      sx={{ mb: isMobile ? 1 : 2 }}
                      size={isMobile ? 'small' : 'medium'}
                      disabled={loading}
                    />
                  )}
                />
                <Controller
                  name="description"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Community Description"
                      fullWidth
                      multiline
                      rows={isMobile ? 2 : 4}
                      margin="normal"
                      error={!!errors.description}
                      helperText={errors.description?.message}
                      sx={{ mb: isMobile ? 1 : 2 }}
                      size={isMobile ? 'small' : 'medium'}
                      disabled={loading}
                    />
                  )}
                />
                <Controller
                  name="tags"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      multiple
                      freeSolo
                      value={field.value ? field.value.split(',').filter(Boolean) : []}
                      options={[]}
                      clearIcon={<ClearIcon fontSize={isMobile ? 'small' : 'medium'} />}
                      onChange={(e, newval) => setValue('tags', newval.join(','))}
                      disabled={loading}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            label={option}
                            {...getTagProps({ index })}
                            onDelete={() => handleDeleteChip('tags', option)}
                            sx={{
                              mr: 0.5,
                              mb: 0.5,
                              fontSize: isMobile ? '0.75rem' : '0.875rem'
                            }}
                            size={isMobile ? 'small' : 'medium'}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Community Tags"
                          placeholder="Type and press enter"
                          margin="normal"
                          error={!!errors.tags}
                          helperText={errors.tags?.message}
                          sx={{ mb: isMobile ? 1 : 2 }}
                          size={isMobile ? 'small' : 'medium'}
                        />
                      )}
                    />
                  )}
                />
                <Controller
                  name="services"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      multiple
                      value={
                        field.value && services.length > 0
                          ? services.filter((service: Service) =>
                              field.value!.includes(service.service_id)
                            )
                          : []
                      }
                      options={services}
                      getOptionLabel={(option: Service) =>
                        option.header || option.shortDescription || option.service_id || 'Unknown'
                      }
                      clearIcon={<ClearIcon fontSize={isMobile ? 'small' : 'medium'} />}
                      onChange={(e, newval) =>
                        setValue(
                          'services',
                          newval.map((service: Service) => service.service_id)
                        )
                      }
                      disabled={loading || services.length === 0}
                      renderTags={(value, getTagProps) =>
                        value.map((option: Service, index: number) => (
                          <Chip
                            label={option.header || option.shortDescription || option.service_id}
                            {...getTagProps({ index })}
                            onDelete={() => handleDeleteChip('services', option.service_id)}
                            sx={{
                              mr: 0.5,
                              mb: 0.5,
                              fontSize: isMobile ? '0.75rem' : '0.875rem'
                            }}
                            size={isMobile ? 'small' : 'medium'}
                          />
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Services"
                          placeholder={
                            services.length > 0 ? 'Select services' : 'No services available'
                          }
                          margin="normal"
                          error={!!errors.services}
                          helperText={errors.services?.message}
                          sx={{ mb: isMobile ? 1 : 2 }}
                          size={isMobile ? 'small' : 'medium'}
                        />
                      )}
                    />
                  )}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box sx={{ mb: isMobile ? 1 : 3 }}>
                <Typography
                  variant={isMobile ? 'subtitle2' : 'h6'}
                  fontWeight="bold"
                  color="textPrimary"
                  gutterBottom
                >
                  Select Administrators
                </Typography>
                <Box
                  sx={{
                    border: `1px solid ${theme.palette.divider}`,
                    borderRadius: 1,
                    p: isMobile ? 1 : 2,
                    backgroundColor: theme.palette.background.paper,
                    maxHeight: isMobile ? '40vh' : '60vh',
                    overflowY: 'auto'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: isMobile ? 1 : 2 }}>
                    <TextField
                      label="Search Administrators"
                      fullWidth
                      margin="normal"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      sx={{ mr: 2 }}
                      size={isMobile ? 'small' : 'medium'}
                      disabled={loading}
                    />
                  </Box>
                  {loading && filteredUsers.length === 0 ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <TableContainer>
                      <Table size={isMobile ? 'small' : 'medium'}>
                        <TableBody>
                          {filteredUsers.map((user: User) => {
                            const userEmail = typeof user?.email === 'string' ? user.email : '';
                            const isSelected =
                              userEmail.length > 0 &&
                              (watch('administrators') || []).includes(userEmail);

                            return (
                              <TableRow
                                key={user.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                              >
                                <TableCell padding="checkbox" sx={{ py: isMobile ? 0.5 : 1 }}>
                                  <Checkbox
                                    checked={isSelected}
                                    onChange={() => {
                                      if (!userEmail) {
                                        return;
                                      }
                                      const adminsField = watch('administrators') || [];
                                      if (isSelected) {
                                        setValue(
                                          'administrators',
                                          adminsField.filter((email) => email !== userEmail)
                                        );
                                      } else {
                                        setValue('administrators', [...adminsField, userEmail]);
                                      }
                                    }}
                                    color="primary"
                                    size={isMobile ? 'small' : 'medium'}
                                    disabled={loading}
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  sx={{
                                    width: 'auto',
                                    minWidth: isMobile ? '100%' : 400,
                                    py: isMobile ? 0.5 : 1
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Avatar
                                      src={avatarUrls[user.id]}
                                      sx={{
                                        width: isMobile ? 24 : 32,
                                        height: isMobile ? 24 : 32,
                                        fontSize: isMobile ? '0.75rem' : '0.875rem'
                                      }}
                                    >
                                      {(userEmail.charAt(0) || '?').toUpperCase()}
                                    </Avatar>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: isMobile ? '0.75rem' : '0.875rem',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                      }}
                                    >
                                      {userEmail || 'Unknown user'}
                                    </Typography>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            p: isMobile ? 1 : 2,
            borderTop: `1px solid ${theme.palette.divider}`,
            justifyContent: 'space-between'
          }}
        >
          <Button
            onClick={handleCloseWithCheck}
            sx={{
              color: 'text.secondary',
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              px: isMobile ? 1 : 2
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit, onError)}
            variant="contained"
            color="primary"
            sx={{
              fontSize: isMobile ? '0.75rem' : '0.875rem',
              px: isMobile ? 1 : 2
            }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : editMode ? 'Save Changes' : 'Add Group'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog for Unsaved Changes */}
      <Dialog open={confirmDialogOpen} onClose={handleCancelClose} maxWidth="xs" fullWidth>
        <DialogTitle>Unsaved Changes</DialogTitle>
        <DialogContent>
          <Typography>You have unsaved changes. Are you sure you want to close?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClose} color="primary" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmClose}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog for Delete Group */}
      <Dialog open={deleteConfirmOpen} onClose={handleCloseDeleteConfirm} maxWidth="xs" fullWidth>
        <DialogTitle>Delete Group</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the group "{currentGroup?.label}"? This action cannot be
            undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm} color="primary" disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleDeleteGroup} color="error" variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Toasts */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          <AlertTitle>
            {snackbar.severity.charAt(0).toUpperCase() + snackbar.severity.slice(1)}
          </AlertTitle>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default GroupsAddEditModal;